import { RedirectView } from '@webapp/containers/RedirectView'

export const RedirectPage = RedirectView
